import { render, staticRenderFns } from "./Downloadable.vue?vue&type=template&id=0be060ac&scoped=true"
import script from "./Downloadable.vue?vue&type=script&lang=js"
export * from "./Downloadable.vue?vue&type=script&lang=js"
import style0 from "./Downloadable.vue?vue&type=style&index=0&id=0be060ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be060ac",
  null
  
)

export default component.exports